/* eslint-disable */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, useLocation } from 'react-router-dom';
import App from './App';
import StoreProvider from './Store/StoreProvider';
import { FileUploadProvider } from './Store/FileUploadProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <StoreProvider >
      <FileUploadProvider>
        <App />
      </FileUploadProvider>
    </StoreProvider>
  </BrowserRouter>
  // </React.StrictMode>,
);
